<script setup lang="ts">
import { computed } from 'vue'
import type { ZonedDateTime } from '@internationalized/date'

const dateValue = defineModel<ZonedDateTime>({ required: true })

withDefaults(
  defineProps<{
    label?: string
    name?: string
    required?: boolean
  }>(),
  {
    label: 'Beginn des Problems',
    name: 'startTime',
    required: true
  }
)

const formattedDate = computed(() => {
  if (!dateValue.value) return 'Datum/Zeit wählen'
  return dateValue.value.toDate().toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
})
</script>

<template>
  <UFormField :label="label" :name="name" :required="required" class="w-full">
    <UPopover>
      <UButton
        color="neutral"
        variant="subtle"
        icon="i-lucide-calendar"
        class="w-full justify-start"
      >
        {{ formattedDate }}
      </UButton>

      <template #content>
        <div class="p-2 space-y-4">
          <UCalendar v-model="(dateValue as any)" class="mx-auto" />
          <div class="flex items-center justify-between border-t border-neutral-200 dark:border-neutral-800 pt-4 px-2">
            <div class="flex items-center gap-2">
              <UIcon name="i-lucide-clock" class="size-4 text-neutral-500" />
              <span class="text-sm font-medium">Uhrzeit</span>
            </div>
            <UInputTime
              v-model="(dateValue as any)"
              variant="outline"
              size="sm"
              :hour-cycle="24"
            />
          </div>
        </div>
      </template>
    </UPopover>
  </UFormField>
</template>
